import styled from "@emotion/styled";
import { TableRow } from "@mui/material";

const StyledTableRow = styled(TableRow)(({ theme }: any) => ({
  "&:nth-of-type(odd)": {
    // backgroundColor: theme.palette.action.hover,
    alignItems: "center",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
    alignItems: "center",
  },
}));

export default StyledTableRow;
